module.exports = __webpack_public_path__ + "img/t9.9be237e0.jpg";